
import { mapState, mapActions, mapGetters } from "vuex";
import logo from "~/assets/images/logo.png";
import currencyConverter from "../common/currency-converter.vue";
export default {
  components: { currencyConverter },
  props: {
    invoiceData: Object,
    isPdf: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      titles: ["Date", "Plan", "Qty", "Price Sub", "Total"],
      logo
    };
  },
  computed: {
    ...mapState("restaurant", ["locationDetails", "businessDetails"]),
    isPaid() {
      return (
        this.invoiceData.invoice &&
        this.invoiceData.invoice.payment_status === "paid"
      );
    }
  }
};
